import axios from "axios";

/** FrontYard */

const createFrontYard = (params, callback) => {
  axios.post(`/v3/api/real-estate/front-yards`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const searchFrontYards = (params, callback) => {
  axios.get(`/v3/api/real-estate/front-yards`, { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const getFrontYardDetail = (params, callback) => {
  axios.get(`/v3/api/real-estate/front-yards/${params.id}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateFrontYard = (params, callback) => {
  axios.put(`/v3/api/real-estate/front-yards/${params.id}`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const deleteFrontYard = (params, callback) => {
  axios.delete(`/v3/api/real-estate/front-yards/${params.id}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** LivingArea  */

const createLivingArea = (params, callback, errorCallback) => {
  axios.post(`/v3/api/real-estate/living-areas`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
      if (res && res.status !== 200)
        errorCallback && errorCallback(res.data);
    });
};

const searchLivingAreas = (params, callback) => {
  axios.get(`/v3/api/real-estate/living-areas`, { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const getLivingAreaDetail = (params, callback) => {
  axios.get(`/v3/api/real-estate/living-areas/${params.id}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateLivingArea = (params, callback, errorCallback) => {
  axios.put(`/v3/api/real-estate/living-areas/${params.id}`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
      if (res && res.status !== 200)
        errorCallback && errorCallback(res.data);
    });
};

const deleteLivingArea = (params, callback) => {
  axios.delete(`/v3/api/real-estate/living-areas/${params.id}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** Environment */

const createEnvironment = (params, callback) => {
  axios.post("/v2/api/real-estate/environments", params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const searchEnvironmentsV2 = (params, callback) => {
  axios.get("/v2/api/real-estate/environments", { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateEnvironment = (params, callback) => {
  axios.put(`/v2/api/real-estate/environments/${params.id}`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const deleteEnvironment = (params, callback) => {
  axios.delete(`/v2/api/real-estate/environments/${params.id}`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** Education */

const createEducation = (params, callback) => {
  axios.post("/v2/api/real-estate/educations", params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const searchEducationsV2 = (params, callback) => {
  axios.get(`/v2/api/real-estate/educations`, { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateEducation = (params, callback) => {
  axios.put(`/v2/api/real-estate/educations/${params.educationType}/${params.id}`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const deleteEducation = (params, callback) => {
  axios.delete(`/v2/api/real-estate/educations/${params.educationType}/${params.id}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** Complex */

const searchComplexesV3 = (params, callback) => {
  axios.get(`/v3/api/real-estate/complexes`, { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const deleteComplexV3 = (params, callback) => {
  axios.delete(`/v3/api/real-estate/complexes/${params.id}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const getComplexDetailV3 = (params, callback) => {
  axios.get(`/v3/api/real-estate/complexes/${params.id}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateComplexLandmarkV3 = (params, callback) => {
  axios.put(`/v3/api/real-estate/complexes/${params.id}:updateLandmark`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateComplexBookmarkV3 = (params, callback) => {
  axios.put(`/v3/api/real-estate/complexes/${params.id}:updateBookmark`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateComplexLivingAreaV3 = (params, callback) => {
  axios.put(`/v3/api/real-estate/complexes/${params.id}:updateLivingArea?livingAreaId=${params.livingAreaId}`)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** ComplexTransport */

const updateComplexTransportV3 = (params, callback) => {
  axios.put(`/v3/api/real-estate/complexes/${params.complexId}:updateTransport`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** ComplexEducation */

const updateComplexEducationV3 = (params, callback) => {
  axios.put(`/v3/api/real-estate/complexes/${params.complexId}:updateEducation`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** ComplexEvaluation */

const updateComplexEvaluationV3 = (params, callback) => {
  axios.put(`/v3/api/real-estate/complexes/${params.complexId}:updateEvaluation`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

/** ComplexArea */

const searchComplexAreaV4 = (params, callback) => {
  axios.get(`/v4/api/real-estate/complex-areas`, { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const searchComplexAreaByPriceV4 = (params, callback) => {
  axios.get(`/v4/api/real-estate/complex-areas-by-price`, { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const searchComplexAreaInComplexV4 = (params, callback) => {
  axios.get(`/v4/api/real-estate/complex-areas-in-complex`, { params })
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

const updateComplexAreaPriceV4 = (params, callback) => {
  axios.put(`/v4/api/real-estate/complex-areas/${params.complexAreaId}`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

// TBU
const updateComplexAreaPrice = (params, callback) => {
  axios.post(`/v2/api/real-estate/complex-areas/${params.complexAreaId}`, params)
    .then((res) => {
      if (res && res.status === 200)
        callback && callback(res.data);
    });
};

export {
  createEducation,
  createEnvironment,
  createFrontYard,
  createLivingArea, deleteComplexV3, deleteEducation,
  deleteEnvironment,
  deleteFrontYard,
  deleteLivingArea, getComplexDetailV3,
  getFrontYardDetail,
  getLivingAreaDetail,
  searchComplexAreaByPriceV4,
  searchComplexAreaInComplexV4,
  searchComplexAreaV4,
  searchComplexesV3,
  searchEducationsV2,
  searchEnvironmentsV2,
  searchFrontYards,
  searchLivingAreas,
  updateComplexAreaPrice,
  updateComplexAreaPriceV4,
  updateComplexBookmarkV3,
  updateComplexEducationV3,
  updateComplexEvaluationV3,
  updateComplexLandmarkV3,
  updateComplexLivingAreaV3,
  updateComplexTransportV3,
  updateEducation,
  updateEnvironment,
  updateFrontYard,
  updateLivingArea
};
